import React from 'react';
import Card from '../cards/Card';

function OpponentCard({ player, isDealer }) {
  if (!player?.hand) return null;

  const hand = Object.values(player.hand);
  const topRow = hand.slice(0, 3);
  const bottomRow = hand.slice(3, 6);

  return (
    <div className="opponent">
      <div className="opponent__name">{isDealer && <span className="opponent__dealer-star">★ </span>}{player.displayName}</div>
      <div className="opponent__hand">
        <div className="opponent__row">
          {topRow.map((card, i) => (
            <Card
              key={i}
              card={card}
              faceUp={card.faceUp}
              size="small"
              disabled
            />
          ))}
        </div>
        <div className="opponent__row">
          {bottomRow.map((card, i) => (
            <Card
              key={i + 3}
              card={card}
              faceUp={card.faceUp}
              size="small"
              disabled
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default OpponentCard;
